<template>
  <div>
    <input-field label="设备名称" v-model="data.name" :disabled="!editable"></input-field>
    <select-field label="PLC 厂商" v-model="data.manufacturer" :list="selectData.manufacturer" :disabled="!editable"></select-field>
    <select-field label="PLC 型号" v-model="data.model" :list="selectData.model" :disabled="!editable" :note="selectData.seriesNote"></select-field>
    <select-field label="连接方式" v-model="data.connectionType" @input="ConnectionTypeChange" :list="selectData.connectionType" :disabled="!editable"></select-field>
    <select-field label="挂载接口类型" v-model="data.interfaceType" :list="selectData.interfaceType" :disabled="!editable"></select-field>
    <select-field label="挂载接口实例" v-model="data.interface" :list="interfaceInstanceList" invalid-feedback="若实例不存在需切换至 '接口视图' 页面添加实例" :disabled="!editable"></select-field>

    <fields v-model="data.args" :fields="fieldsData" :disabled="!editable"></fields>
    <submit-field @click="submit" :disabled="!editable || !isValid">确定</submit-field>
  </div>
</template>

<script>
  import InputField from '@/components/utils/input-field'
  import SelectField from '@/components/utils/select-field'
  import SubmitField from '@/components/utils/submit-field'
  import Fields from '@/components/utils/fields'
  import { Interface } from '@/models/interface'

  const data = {
    data: {
      name: '',
      manufacturer: '',
      model: '',
      connectionType: '',
      interfaceType: '',
      interface: '',
      module: '',
      args: {}
    },
    interfaceInstanceList: []
  }

  export default {
    created () {
      this.refreshData()
      this._interface = new Interface()
    },
    data: () => data,
    components: {
      InputField,
      SelectField,
      SubmitField,
      Fields
    },
    props: {
      defaults: {
        required: false,
        default: () => Object.create(null),
        type: Object,
        editable: false
      },
      event: {
        required: false,
        default: 'plc-device-data',
        type: String
      },
      editable: {
        required: false,
        default: true,
        type: Boolean
      }
    },
    methods: {
      submit () {
        let data = Object.assign({
          _id: this.defaults._id
        }, this.data)
        data.args = Object.create(null)
        if (this.selectData.moduleArgs) {
          Object.keys(this.selectData.moduleArgs).forEach(key => {
            data.args[key] = this.data.args[key]
          })
        }

        data.module = this.selectData.module

        this.$emitter.emit(this.event, data)

        this.$emitter.once(`${this.event}Resp`, err => {
          if (!err) {
            this.editable = false
          }
        })
      },
      type2Field (type) {
        let map = {
          'string': 'input-field',
          'number': 'number-field'
        }

        return map[type]
      },
      refreshData () {
        [
          'name',
          'manufacturer',
          'model',
          'connectionType',
          'interfaceType',
          'interface'
        ].forEach(key => {
          this.$set(this.data, key, this.defaults[key])
        })

        for (let [key, value] of Object.entries(this.defaults.args)) {
          this.$set(this.data.args, key, value)
        }
      },
      ConnectionTypeChange () {
        this._connectionTypeChange = true
      }
    },
    computed: {
      plcInfo () {
        return this.$store.state.Config.plc
      },
      selectData () {
        const self = this
        const obj = {
          get manufacturer () {
            return Object.keys(self.plcInfo)
          },
          get model () {
            try {
              return Object.keys(self.plcInfo[self.data.manufacturer])
            } catch (err) {
              return []
            }
          },
          get connectionType () {
            try {
              return Object.keys(self.plcInfo[self.data.manufacturer][self.data.model].connection)
            } catch (err) {
              return []
            }
          },
          get interfaceType () {
            try {
              return self.plcInfo[self.data.manufacturer][self.data.model].connection[self.data.connectionType].interface
            } catch (err) {
              return []
            }
          },
          get moduleArgs () {
            try {
              return self.plcInfo[self.data.manufacturer][self.data.model].connection[self.data.connectionType].moduleArgs
            } catch (err) {
              return []
            }
          },
          get module () {
            try {
              return self.plcInfo[self.data.manufacturer][self.data.model].connection[self.data.connectionType].module
            } catch (err) {
              return []
            }
          },
          get seriesNote () {
            try {
              return self.plcInfo[self.data.manufacturer][self.data.model].seriesNote
            } catch (err) {
              return null
            }
          }
        }

        return Object.assign(Object.create(null), obj)
      },
      fieldsData () {
        let fields = []
        let moduleArgs = this.selectData.moduleArgs

        if (!Array.isArray(moduleArgs) && typeof moduleArgs === 'object') {
          /* generate fields */
          for (let [key, value] of Object.entries(moduleArgs)) {
            if (['string', 'number', 'boolean'].indexOf(typeof value) !== -1) {
              this.$set(this.data.args, key, value)
            } else if (typeof value === 'object') {
              if (this._connectionTypeChange) {
                this.$set(this.data.args, key, value.default)
              }
              fields.push({
                name: key,
                field: this.type2Field(value.type),
                props: {
                  label: value.name
                }
              })
            }
          }
        }
        this._connectionTypeChange = false
        return fields
      },
      isValid () {
        /*
        return this.data.name &&
               this.data.manufacturer &&
               this.data.model &&
               this.data.connectionType &&
               this.data.interfaceType &&
               this.data.interface &&
               this.fieldsData.every(field => !!this.data.args[field.name])
               */
        return true
      }
    },
    watch: {
      defaults (value) {
        this.refreshData()
      },
      async 'data.interfaceType' (value) {
        let list = await this._interface.all(value)
        this.interfaceInstanceList = list.map(iface => {
          return {
            key: iface.name,
            value: iface.id
          }
        })
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/home/forms/plc-device.vue